import request from '@/utils/request'


export function joinCompany(query) {
  return request({
    url: '/User/company',
    method: 'post',
    data: query
  })
}


export function changeCompany(query) {
  return request({
    url: '/User/company',
    method: 'put',
    params: query
  })
}

export function quitCompany(query) {
  return request({
    url: '/User/company',
    method: 'delete',
    params: query
  })
}

export function getUser(query) {
  return request({
    url: '/User/info',
    method: 'get',
    params: query
  })
}

export function editUser(query) {
  return request({
    url: '/User/info',
    method: 'put',
    params: query
  })
}


export function setPerosnCustomer(query) {
  return request({
    url: '/User/perosn',
    method: 'post',
    data: query
  })
}


export function forgetPassord(query) {
  return request({
    url: 'User/password',
    method: 'post',
    data: query
  })
}

export function editPassord(query) {
  return request({
    url: 'User/password',
    method: 'put',
    params: query
  })
}

export function customerStatistics(query) {
  return request({
    url: 'User/customerStatistics',
    method: 'get',
    params: query
  })
}




export function noticeList(query) {
  return request({
    url: 'User/notice',
    method: 'get',
    params: query
  })
}


export function noticeStatus(query) {
  return request({
    url: 'User/noticeStatus',
    method: 'get',
    params: query
  })
}


export function readNotice(query) {
  return request({
    url: 'User/notice',
    method: 'put',
    params: query
  })
}

export function registerCompany(query) {
  return request({
    url: 'User/register',
    method: 'post',
    data: query
  })
}
export function inviteCompany(query) {
  return request({
    url: 'User/invite',
    method: 'post',
    data: query
  })
}
export function authLogin(query) {
  return request({
    url: 'User/authLogin',
    method: 'post',
    data: query
  })
}







// WEBPACK FOOTER //
// ./src/api/user.js